// extracted by mini-css-extract-plugin
export default {"closeButton":"Message_closeButton__b-6Ej","closeButton--success":"Message_closeButton--success__BUUsE","main":"Message_main__ziCdH"};